<template>
  <div class="toast-container">
    <!-- Toast Stack - positioned absolutely to avoid layout shifts -->
    <!-- z-80: must clear the board workspace (z-61) and chat panel (z-70) -->
    <div class="fixed top-4 right-4 z-[80] pointer-events-none">
      <div
        v-for="(toast, index) in toasts"
        :key="toast.id"
        class="pointer-events-auto mb-2"
        :style="{ transform: `translateY(${index * 8}px)` }"
      >
        <Toast
          :toast="toast"
          @dismiss="removeToast"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Toast from './Toast.vue'
import toastService from '@/services/toastService.js'

export default {
  name: 'ToastContainer',
  components: {
    Toast
  },
  data() {
    return {
      toasts: toastService.toasts
    }
  },
  methods: {
    removeToast(toastId) {
      toastService.removeToast(toastId)
    }
  }
}
</script>

<style scoped>
.toast-container {
  /* Ensure container doesn't interfere with page layout */
  position: fixed;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  pointer-events: none;
  z-index: 80;
}
</style>
